// extracted by mini-css-extract-plugin
export default {"dark":"XU9VV_","light":"_TaFbJ"};